import { Loader2 } from "lucide-react";
import { Outlet } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useRagAuthReady } from "../hooks/useRagAuthReady.js";

export function RagAuthGate() {
  const { ready, error, retry } = useRagAuthReady();

  if (ready) {
    return <Outlet />;
  }

  if (error) {
    return (
      <section className="flex flex-1 flex-col items-center justify-center gap-3 p-6">
        <p className="text-sm text-red-400">{error}</p>
        <Button variant="outline" onClick={() => void retry()}>
          Retry
        </Button>
      </section>
    );
  }

  return (
    <section className="flex flex-1 items-center justify-center p-6">
      <Loader2 className="h-8 w-8 animate-spin text-violet-400" />
    </section>
  );
}
